export default "__VITE_ASSET__BcqxSCG3__"